module.exports = __webpack_public_path__ + "static/media/washingtonTut.e595c1bc.jpg";